const ACTIONABLE_SIGNATURE_STATUSES = new Set([
    "pending",
    "sent",
    "partially_signed",
    "counter_sign_pending",
]);
export function buildAttentionItems(input) {
    const items = [];
    for (const doc of input.sharedDocuments) {
        items.push({
            id: `review-${doc.grantId}`,
            title: doc.title,
            kind: "review",
            meta: doc.unreadCount > 0 ? `${doc.unreadCount} unread` : undefined,
        });
    }
    for (const signature of input.signatures) {
        if (!ACTIONABLE_SIGNATURE_STATUSES.has(signature.status))
            continue;
        const signedCount = signature.signers.filter((signer) => signer.signedAt).length;
        items.push({
            id: `signature-${signature.id}`,
            title: signature.title,
            kind: "signature",
            meta: `${signedCount}/${signature.signers.length} signed`,
        });
    }
    for (const approval of input.approvals) {
        if (approval.status === "approved")
            continue;
        items.push({
            id: `approval-${approval.id}`,
            title: approval.title,
            kind: "approval",
            meta: "Decision needed",
        });
    }
    return items;
}
export function getNextMilestone(milestones) {
    const openMilestones = milestones.filter((milestone) => milestone.status !== "achieved");
    return openMilestones.sort((a, b) => {
        const aTime = a.targetDate ? new Date(a.targetDate).getTime() : Number.MAX_SAFE_INTEGER;
        const bTime = b.targetDate ? new Date(b.targetDate).getTime() : Number.MAX_SAFE_INTEGER;
        return aTime - bTime;
    })[0];
}
export function sumPublishedTotals(totals) {
    return totals.reduce((sum, value) => sum + value, 0);
}
//# sourceMappingURL=portal-home-model.js.map